import { SearchUrlParamBuilder } from '@/core/utils'
import axios from 'axios'

const URL_PATH = 'api/revisoes'

class RevisoesApiClient {
	async buscarRevisoes(paginacao, filtros) {
		let URL = new SearchUrlParamBuilder({
			urlPath: URL_PATH,
			filters: filtros,
			pagingAndSorting: paginacao,
		}).buildFiltroPadraoEAvancado()
		return await axios.get(URL)
	}

	async excluirRevisao(idRevisao) {
		let URL = `${URL_PATH}/${idRevisao}`
		return await axios.delete(URL)
	}

	async inserirRevisao(objParam) {
		return await axios.post(URL_PATH, objParam)
	}

	buscarRevisaoPorId(idRevisao) {
		return axios.get(`${URL_PATH}/${idRevisao}`)
	}

	editarRevisao(idRevisao, body) {
		return axios.put(`${URL_PATH}/${idRevisao}`, body)
	}

	alterarSituacao(idRevisao, body) {
		return axios.patch(`${URL_PATH}/${idRevisao}/alterar-situacao`, body)
	}
}

export default new RevisoesApiClient()
